"use strict";

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  text-indent: ", ";\n  text-transform: ", ";\n  font-style: ", ";\n  white-space: ", ";\n  opacity: ", ";\n  box-sizing: ", ";\n  text-decoration: ", ";\n  transition: ", ";\n\n  &:hover {\n    cursor: pointer;\n    color: ", ";\n    ", "\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _styledSystem = require("styled-system");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var Link = _styledComponents.default.a(_templateObject(), _styledSystem.fontFamily, _styledSystem.fontSize, _styledSystem.width, _styledSystem.height, _styledSystem.maxWidth, _styledSystem.minWidth, _styledSystem.space, _styledSystem.borders, _styledSystem.color, _styledSystem.textAlign, _styledSystem.lineHeight, _styledSystem.fontWeight, _styledSystem.letterSpacing, _styledSystem.borderColor, _styledSystem.display, function (props) {
  return props.textIndent;
}, function (props) {
  return props.textTransform || 'none';
}, function (props) {
  return props.fontStyle || 'normal';
}, function (props) {
  return props.whiteSpace || 'normal';
}, function (props) {
  return props.opacity || '1';
}, function (props) {
  return props.boxSizing || 'content-box';
}, function (props) {
  return props.textDecoration || 'none';
}, function (props) {
  return props.transition || 'none';
}, function (props) {
  return props.color || props.theme.colors.wagGreen || 'blue';
}, function (props) {
  return props.hoverColor && "\n      color: " + props.hoverColor + ";\n    ";
});

Link.defaultProps = {
  href: '#'
};
var _default = Link;
exports.default = _default;